/**
 * Store registry — holds the Redux store reference without creating circular imports.
 *
 * Usage:
 *  - store.ts calls registerStore(store) after creation
 *  - api.config.ts calls getStore() inside interceptor callbacks (never at module load time)
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
type AnyStore = { dispatch: (action: any) => void };
/* eslint-enable @typescript-eslint/no-explicit-any */

let _store: AnyStore | null = null;

export function registerStore(store: AnyStore): void {
  _store = store;
}

export function getStore(): AnyStore | null {
  return _store;
}
